var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQiTechBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 189,
    viewBox: "0 0 301 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8923 22.8514C59.7933 22.8514 64.6944 24.4839 68.6152 27.096C72.8627 30.0346 75.8034 33.9527 77.7638 38.5238C79.7242 43.095 80.0509 48.3191 79.0707 53.2168C78.0905 58.1144 75.8034 62.6855 72.2093 66.2771C68.6152 69.8688 64.3676 72.1543 59.4666 73.1339C54.5655 74.1134 49.6645 73.4604 45.0902 71.5013C40.5159 69.5422 36.595 66.2771 33.9812 62.0325C31.3673 57.7879 29.7336 52.8902 29.7336 47.9926C29.7336 44.7275 30.3871 41.4624 31.694 38.1973C33.001 35.2587 34.6346 32.3201 37.2485 30.0346C39.5357 27.749 42.4763 25.7899 45.4169 24.4839C48.6843 23.5044 51.6249 22.8514 54.8923 22.8514Z",
    fill: "url(#paint0_linear_389_575)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.736 152.475C231.329 127.008 203.23 88.153 178.398 115.253C159.774 135.497 178.725 151.169 188.527 160.965C214.012 186.759 247.666 221.369 275.112 244.551C284.26 252.387 290.795 254.346 297.33 255.979C317.588 260.55 329.023 242.919 325.102 225.287C321.508 208.309 301.577 191.657 297.657 189.698C312.033 169.454 321.182 145.945 324.449 121.13C329.023 88.153 323.469 54.849 308.439 25.4631C286.874 -16.3301 248.32 -43.1039 218.587 -52.2462C202.576 -57.1439 187.873 -55.5113 180.358 -49.9606C171.537 -43.757 167.289 -28.411 174.477 -16.3301C175.784 -14.0446 177.418 -12.0855 179.378 -10.7795C181.339 -9.14692 183.626 -8.16739 185.913 -7.51437C196.369 -4.9023 216.626 0.321854 233.943 14.3618C253.221 29.3812 266.617 50.9309 271.845 75.0926C278.706 100.887 273.805 132.885 260.736 152.475Z",
    fill: "url(#paint1_linear_389_575)",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9414 105.784C21.2383 111.988 19.2779 125.375 22.2185 139.088C27.1195 161.618 45.7435 192.636 59.7931 207.656C81.3577 229.532 107.17 246.184 137.23 252.714C162.061 257.938 189.181 258.264 203.884 253.04C225.448 245.857 229.042 204.39 193.428 203.737C187.547 203.737 181.339 204.064 174.477 204.39C160.755 205.043 147.032 202.758 133.962 197.86C120.893 192.963 109.13 185.453 99.3282 175.658C90.833 167.821 84.2983 158.679 79.0705 148.231C75.8032 141.701 73.1893 134.844 70.5754 128.314C69.2685 124.396 69.5952 120.477 66.9813 116.559C63.714 111.335 58.8129 107.417 52.9317 105.458C48.0306 103.172 41.4959 103.499 35.9414 105.784Z",
    fill: "url(#paint2_linear_389_575)",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.537 34.6044C146.378 34.6044 153.893 36.8899 160.101 41.1346C166.636 45.3792 171.537 51.5829 174.477 59.0926C177.418 66.2758 178.072 74.4386 176.765 81.9483C175.131 89.7845 171.537 96.6412 165.982 102.192C160.428 107.743 153.566 111.661 146.051 112.967C138.537 114.599 130.695 113.62 123.507 110.681C116.318 107.743 110.437 102.518 106.19 95.9882C101.942 89.458 99.655 81.6218 99.655 73.7855C99.655 63.3372 103.903 53.2154 111.091 45.7057C118.606 38.849 128.408 34.6044 138.537 34.6044Z",
    fill: "url(#paint3_linear_389_575)",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.635 -69.8774C106.516 -69.8774 112.397 -67.9184 117.298 -64.6533C122.199 -61.3882 126.12 -56.4905 128.407 -50.6134C130.694 -44.7362 131.348 -38.859 130.041 -32.6553C128.734 -26.7782 126.12 -21.2275 121.872 -16.6564C117.625 -12.4117 112.397 -9.47315 106.516 -8.16711C100.635 -6.86107 94.4266 -7.5141 88.872 -9.79966C83.3175 -12.0852 78.7432 -16.0033 75.1491 -21.2275C71.8818 -26.4517 69.9214 -32.3288 69.9214 -38.5325C69.9214 -46.6953 73.1887 -54.5315 78.7432 -60.4087C84.6245 -66.6123 92.4661 -69.8774 100.635 -69.8774Z",
    fill: "url(#paint4_linear_389_575)",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9507 -35.2677C22.8715 -35.2677 26.4656 -34.2882 29.733 -32.0026C33.0003 -29.7171 35.2875 -26.7785 36.9212 -23.1869C38.2281 -19.5953 38.8816 -15.6771 37.9014 -11.759C36.9212 -7.84092 35.2875 -4.57582 32.6736 -1.96375C30.0597 0.648331 26.4656 2.60739 22.8715 3.26041C19.2774 3.91343 15.3566 3.58692 11.7625 2.28088C8.1684 0.648338 5.22778 -1.63724 3.26736 -4.90233C1.30694 -8.16743 0 -11.759 0 -15.6771C0 -20.9013 1.96042 -25.7989 5.55451 -29.3906C9.14861 -32.9822 14.0496 -35.2677 18.9507 -35.2677Z",
    fill: "url(#paint5_linear_389_575)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_389_575",
    x1: 168.579,
    y1: -6.98782,
    x2: -36.6856,
    y2: 145.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_389_575",
    x1: 168.579,
    y1: -6.98782,
    x2: -36.6856,
    y2: 145.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_389_575",
    x1: 168.579,
    y1: -6.98782,
    x2: -36.6856,
    y2: 145.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_389_575",
    x1: 168.579,
    y1: -6.98782,
    x2: -36.6856,
    y2: 145.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_389_575",
    x1: 168.579,
    y1: -6.98782,
    x2: -36.6856,
    y2: 145.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_389_575",
    x1: 168.579,
    y1: -6.98782,
    x2: -36.6856,
    y2: 145.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQiTechBg);
export default __webpack_public_path__ + "static/media/QITechBG.b8ea6009f6e6fd2f514b3c791f0466b6.svg";
export { ForwardRef as ReactComponent };